import React, { useEffect, useMemo, useRef, useState } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Paper,
  TextField,
  Grid,
  Alert,
  MenuItem,
  useTheme,
  FormControlLabel,
  useMediaQuery,
  Checkbox,
  Slide
} from '@mui/material';
import GlobalStyles from '@mui/material/GlobalStyles';
import { Link, useParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Footer from '../components/Footer';
import { promotionsApi } from '../services/api';

const strings = {
  de: {
    brand: 'Gemeinschaftspraxis\nHörnesgasse',
    topHero: 'Körperarbeit nach der Grinberg Methode',
    heroTitle: 'ENDLICH',
    heroTitle2: 'WIEDER',
    heroTitle3: 'WOHLFÜHLEN',
    offer: 'Dein Spezial-Angebot nur für BesucherInnen des Wien Mitte Landstraßenfestes: Erstsitzung für nur 60 Euro!',
    cta: 'Jetzt Sitzung anfragen',
    scrollToLearnMore: 'nach unten scrollen, um mehr zu erfahren',
    whatWeOffer: 'Was beinhaltet die Erstsitzung?',
    whatWeOffer2: '30 min Fußanalye und\n60 min Körperarbeit\nInsgesamt 90 min für nur 60 Euro!',
    footHeader: 'Fußanalyse',
    bodyHeader: 'Körperarbeit',
    howItWorks: 'WIE FUNKTIONIERT DIE GRINBERG METHODE?',
    howItWorks2: 'Stell dir vor, jemand hilft dir durch Berührung, deine Wahrnehmung im Körper dorthin zu lenken, wo du unbewusst Spannungen hältst, und zeigt dir, wie du sie selbst lösen kannst. Denn dort entstehen oft auch Symptome wie Schmerzen und Unruhe.  Bei uns erwartet dich eine intensive körperliche Reise zu deinen Empfindungen und Bedürfnissen, die dich zu einem höheren Energielevel und mehr Lebensfreude führt.',
    placeholderBullet: 'Kurzer Platzhaltertext (19 Wörter) zur Beschreibung dieses Angebotsabschnitts für bessere Verständlichkeit.',
    bullet1: "Wir beginnen damit, deine Füße genau zu untersuchen. Die Füße sind für uns wie eine Landkarte. Sie verraten durch Eigenschaften wie Temperatur, Farbe und Konsistenz, wie du durchs Leben gehst. ",
    bullet2: "Wir erkennen Schmerzen und Blockaden; genauso wie Potentiale.",
    bullet3: "Die Fußanalyse zeigt, wo wir in der Körperarbeit ansetzen können. Wir legen gemeinsam ein Ziel fest, um klarzustellen, was du brauchst, um dich wieder wohler zu fühlen.",
    bullet4: "Dein Körper erzählt uns viel: Mit Berührung, Anleitung und Bewegung zeigen wir dir, wo du Spannung festhältst.",
    bullet5: "Statt auszuweichen oder Schmerz zu vermeiden, lernst du diese Muster bewusst wahrzunehmen, zu verändern und loszulassen.",
    bullet6: "Das eröffnet dir neue Möglichkeiten, wie du dich bewegst, fühlst und mit Herausforderungen umgehst. So entsteht mehr Aufmerksamkeit und Wohlbefinden im Alltag.",
    paragraphheader:'WAS BRINGTS DIR?',
    paragraph: 'Weniger Schmerzen. Innere Ruhe.\nMehr Kraft im Alltag. Du erkennst Wege, wie du selbst in dein Wohlbefinden kommen kannst. Das Ergebnis ist eine bessere Verbindung zu deinem Körper und all seinen Signalen.',
    formHeader: 'Erstsitzung anfragen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    availability: 'Verfügbarkeit',
    availabilityTip: 'Z. B.: Wochentage/Zeiten, bevorzugte Wochen, früheste/späteste Uhrzeit',
    practitionerPreference: 'Praktiker:innenpräferenz (optional)',
    comments: 'Weitere Kommentare/Ziele (optional)',
    submit: 'Absenden',
    thankYou: 'Danke! Wir haben Ihre Anfrage erhalten. Sie erhalten eine Bestätigung per E-Mail und wir melden uns bald.',
    ended: 'Diese Aktion ist leider beendet.',
    notFound: 'Seite nicht gefunden.',
    invalidForm: 'Bitte füllen Sie alle Pflichtfelder korrekt aus.',
    privacyPolicy: 'Ich stimme der Kontaktaufnahme für weitere Informationen zu.',
    privacyPolicyError: 'Sie müssen der Datenschutzerklärung zustimmen.',
    morning: 'Vormittag',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    availabilityError: 'Bitte wählen Sie mindestens einen Zeitpunkt.',
    emailError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    phoneError: 'Bitte geben Sie eine gültige Telefonnummer ein.',
    noPreference: 'Keine Präferenz'
  },
  en: {
    brand: 'Gemeinschaftspraxis\nHörnesgasse',
    topHero:"Bodywork according to the Grinberg Method",
    heroTitle: 'AT LAST',
    heroTitle2: 'RETURN TO',
    heroTitle3:'WELL-BEING',
    offer: 'Your special offer only for visitors of the Wien Mitte Landstraßenfest: First session for only 60 euros!',
    cta: 'Request a session now',
    scrollToLearnMore: 'scroll down to learn more',
    whatWeOffer: 'What does the first session include?',
    whatWeOffer2: '30 min foot analysis and\n60 min bodywork\nA total of 90 min for only 60 euros!',
    footHeader: 'Foot Analysis',
    bodyHeader: 'Bodywork',
    howItWorks: 'HOW DOES THE GRINBERG METHOD WORK?',
    howItWorks2: 'Imagine someone helps you, through touch, to direct your awareness in the body to where you unconsciously hold tension, and shows you how to release it yourself. Because that’s often where symptoms like pain and restlessness arise. With us, you can expect an intensive physical journey into your sensations and needs, leading you to a higher energy level and more joy of life.',
    placeholderBullet: 'Short placeholder text (19 words) to describe this offer section for better understanding.',
    bullet1: "We start by carefully examining your feet. For us, the feet are like a map. Their qualities—such as temperature, color, and consistency—reveal how you move through life.",
    bullet2: "We identify pain and blockages, as well as potential.",
    bullet3: "The foot analysis shows where we can begin in the bodywork. Together, we set a goal to clarify what you need to feel better again.",
    bullet4: "Your body tells us a lot: With touch, guidance, and movement, we show you where you hold tension.",
    bullet5: "Instead of avoiding or suppressing pain, you learn to consciously notice, change, and release these patterns.",
    bullet6: "This opens new possibilities for how you move, feel, and deal with challenges. This creates more awareness and well-being in everyday life.",
    paragraphheader: 'WHAT’S IN IT FOR YOU?',
    paragraph: 'Less pain. Inner calm.\nMore strength in daily life. You discover ways to create your own well-being. The result is a better connection to your body and all its signals.',
    formHeader: 'Request first session',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    availability: 'Availability',
    availabilityTip: 'E.g.: weekdays/times, preferred weeks, earliest/latest time',
    practitionerPreference: 'Practitioner preference (optional)',
    comments: 'Additional comments/goals (optional)',
    submit: 'Submit',
    thankYou: 'Thank you! We have received your request. You will receive a confirmation by email and we will contact you soon.',
    ended: 'Unfortunately, this offer has ended.',
    notFound: 'Page not found.',
    invalidForm: 'Please fill in all required fields correctly.',
    privacyPolicy: 'I agree to be contacted for further information.',
    privacyPolicyError: 'You must agree to the privacy policy.',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    availabilityError: 'Please select at least one time slot.',
    emailError: 'Please enter a valid email address.',
    phoneError: 'Please enter a valid phone number.',
    noPreference: 'No preference'

  }
};
const practitioners = [
  "Hannah",
  "Sylvester",
  "Nicole",
  "Alexander",
  "Lisbeth",
  "Miriam",
  "Astrid"
];
const days = {
    de: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
    en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
}

const Promotions = () => {
  const { id: slug } = useParams();
  const { language, toggleLanguage } = useLanguage();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const t = useMemo(() => strings[language] || strings.de, [language]);

  // Gating by slug
  const isValidSlug = slug === 'landstrassefest';

  // Date cutoff (Aug 30 current year, inclusive)
  const [promotionActive, setPromotionActive] = useState(true);
  useEffect(() => {
    const now = new Date();
    const cutoff = new Date(now.getUTCFullYear(), 7, 30, 23, 59, 59); // Month index 7 = August
    setPromotionActive(now <= cutoff);
  }, []);

  // Dynamic document title
  const originalTitleRef = useRef(document.title);
  useEffect(() => {
    if (isValidSlug && promotionActive) {
      document.title = t.topHero;
    } else {
      document.title = originalTitleRef.current;
    }
  }, [t.topHero, isValidSlug, promotionActive]);
  useEffect(() => {
    return () => {
      document.title = originalTitleRef.current;
    };
  }, []);

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    availability: '',
    practitionerPreference: '',
    comments: '',
    language: language,
    privacyPolicy: false,
  });

  useEffect(() => {
    setForm((f) => ({ ...f, language }));
  }, [language]);

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const heroRef = useRef(null);
  const ctaRef = useRef(null);
  const formHeaderRef = useRef(null);
  const formRef = useRef(null);
  const videoRef = useRef(null);

  const [showStickyCTA, setShowStickyCTA] = useState(false);
  const [availability, setAvailability] = useState({});
  const updateAvailablityGrid = (index, time, availability) => {
    if( availability[index] ) {
        if( availability[index][time] ) {
            delete availability[index][time];
        }else{
            availability[index][time] = true;
        }
    }else{
        availability[index] = {
            [time]: true
        }
    }
    setAvailability(JSON.parse(JSON.stringify(availability)));
  };
  useEffect(() => {
    var availabilityString = '';
    for(var i = 0; i < days[language].length; i++) {
        if( availability[i] && Object.keys(availability[i]).length > 0 ) {
            availabilityString += days[language][i] + ': ';
            var arrayav = []
            if( availability[i]['morning'] ) arrayav.push(t.morning);
            if( availability[i]['afternoon'] ) arrayav.push(t.afternoon);
            if( availability[i]['evening'] ) arrayav.push(t.evening);
            availabilityString += arrayav.join(', ');
            availabilityString += '\n';
        }
    }
    console.log(availabilityString);
    setForm({ ...form, availability: availabilityString });
  }, [availability, language]);
  useEffect(() => {
    const target = ctaRef.current;
    const headerTarget = formHeaderRef.current;
    if (!target) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setShowStickyCTA(!entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );
    io.observe(target);

    let io2;
    if (headerTarget) {
      io2 = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setShowStickyCTA(false);
            }
          });
        },
        { threshold: 0.3 }
      );
      io2.observe(headerTarget);
    }

    return () => {
      io.disconnect();
      if (io2) io2.disconnect();
    };
  }, []);

  useEffect(() => {
    const el = videoRef.current;
    if (!el) return;

    const handleIntersect = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.muted = true;
          el.play().catch(() => {});
        } else {
          el.pause();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, { threshold: 0.5 });
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    formRef.current?.querySelector('input[name="firstName"]').focus();
  };

  const validate = () => {
    console.log('form.availability',form.availability);
    const newErrors = {};
    if (!form.firstName.trim()) newErrors.firstName = true;
    if (!form.lastName.trim()) newErrors.lastName = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) newErrors.email = true;
    const phoneDigits = form.phone.replace(/\D/g, '');
    if (phoneDigits.length < 7) newErrors.phone = true;
    if (!form.availability.trim()) newErrors.availability = true;
    if(!form.privacyPolicy) newErrors.privacyPolicy = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    if (!validate()) return;

    try {
      setSubmitting(true);
      await promotionsApi.submitLead(slug, form);
      setSubmitted(true);
    } catch (err) {
      setSubmitError(err.message || 'Failed to submit');
    } finally {
      setSubmitting(false);
    }
  };

  const HeaderBar = (
    <Box sx={{ borderBottom: '1px solid rgba(46, 134, 171, 0.1)', bgcolor: 'background.paper' }}>
      <Container maxWidth="lg" sx={{ py: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box component="img" src="/logo_mbg.png" alt="Logo" sx={{ width: 40, height: 40, objectFit: 'contain' }} />
            <Box>
              {t.brand.split('\n').map((line, idx) => (
                <Typography key={idx} variant="subtitle1" sx={{ lineHeight: 1, fontWeight: idx === 0 ? 600 : 400 }}>
                  {line}
                </Typography>
              ))}
            </Box>
          </Box>
          <Button style={{ fontSize: '12px', padding: '4px 8px' }} onClick={toggleLanguage} size="small" variant="outlined">
             <span style={{ display: 'inline' }}>
                <span style={{ display:'inline', textDecoration: language === 'de'?'underline':'none' }}>
                    DE
                    </span>/
                <span style={{ display:'inline', textDecoration: language === 'en'?'underline':'none'}}>
                EN
                </span>
             </span>          
          </Button>
        </Box>
      </Container>
    </Box>
  );

  if (!isValidSlug) {
    return (
      <Box component="main" sx={{ flexGrow: 1 }}>
        {HeaderBar}
        <Container maxWidth="sm" sx={{ py: 8 }}>
          <Alert severity="error">{t.notFound}</Alert>
        </Container>
        <Footer hideBranding />
      </Box>
    );
  }

  if (!promotionActive) {
    return (
      <Box component="main" sx={{ flexGrow: 1 }}>
        {HeaderBar}
        <Container maxWidth="sm" sx={{ py: 8 }}>
          <Alert severity="warning">{t.ended}</Alert>
        </Container>
        <Footer hideBranding />
      </Box>
    );
  }

  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
      <GlobalStyles styles={{
        '.grecaptcha-badge': {
          position: 'static !important',
          display: 'block',
          margin: '-60px 0 0 12px'
        }
      }} />
      {HeaderBar}

      {/* Hero */}
      <Box
        sx={{
          position: 'relative',
          height: { xs: '60vh', md: '60vh', lg: '60vh', xl: '80vh' },
          minHeight: '300px',
          backgroundImage: 'url(/halfhappy.png)',
          backgroundSize: 'cover',
          backgroundPositionX: { xs: '50%', md: '35%', lg: '20%', xl: '30%' },
          backgroundPositionY: { xs: '50%', md: '40%', lg: '20%', xl: '30%' },
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '1rem'
        }}
      >
        
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            bgcolor: 'rgba(0,0,0,0.3)'
          }}
        />
        <Typography variant={isMobile ? 'h5' : 'h3'} 
               sx={{ 
                mb: 0, 
                textAlign: 'center', 
                lineHeight: 1.2, 
                color: 'white',
                fontSize: { xs: '1.5rem', md: '2rem' },
                lineHeight: 1.1,
                fontFamily: 'League Gothic, sans-serif',
                letterSpacing: '0.06em',
                position: 'absolute',
                top: '15px',
                color:"#ffffff"
               }}
            >
              {t.topHero}<span style={{ verticalAlign: 'super', fontSize: '0.5em' }}> ®</span>
            </Typography>
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1}}>
          <Paper
            sx={{
              p: { xs: 2, md: 3 },
              maxWidth: 700,
              borderRadius: 0,
              background: 'transparent',
              boxShadow: 'none',
            }}
          >
              
            <Typography variant={isMobile ? 'h5' : 'h3'} 
               sx={{ 
                mb: 0, 
                textAlign: 'left', 
                lineHeight: 1.2, 
                color: 'white',
                fontSize: { xs: '2.5rem', md: '4rem', lg: '5rem' },
                lineHeight: 1.1,
                fontFamily: 'League Gothic, sans-serif',
                letterSpacing: '0.06em'
               }}
            >
              {t.heroTitle}<br/>
              <span style={{ color: '#5BA3C4' }}>{t.heroTitle2}</span>
              <br/>{t.heroTitle3}
            </Typography>
          </Paper>
        </Container>
        <Box sx={{ position: 'absolute', left: 0, right: 0, bottom: 0, zIndex: 2 }}>
          <Box sx={{ bgcolor: 'primary.light', color: 'white', py: 1.5 }}>
            <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{t.offer}</Typography>
            </Container>
          </Box>
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 } }}>
        {/* Offer banner */}
        

        {/* CTA primary */}
        <Box ref={ctaRef} sx={{ textAlign: 'center', mb: 1 }}>
          <Button variant="contained" size="large" onClick={scrollToForm}>
            {t.cta}
          </Button>
        </Box>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 4 }}>
          {t.scrollToLearnMore}
        </Typography>

        {/* Learn more */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>{t.whatWeOffer}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>{t.whatWeOffer2}</Typography>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>{t.howItWorks}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>{t.howItWorks2}</Typography>
        <Grid container sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <Paper sx={{ p: 2, position: 'relative', overflow: 'hidden' }}>
           <video ref={videoRef} style={{ width: '100%', height: '100%' }} 
           src="https://marscognitechwebsite.blob.core.windows.net/media/hannahblauat/output_720p.mp4?sp=r&st=2025-08-26T12:52:24Z&se=2025-08-31T21:07:24Z&spr=https&sv=2024-11-04&sr=b&sig=ZGrAQYHSW9lx4DtaC6nc5Y%2FtGuA6LGP0%2B1iow2X%2FiIg%3D" 
            muted playsInline preload="metadata"
            controlsList="nodownload noplaybackrate noremoteplayback"
            disablePictureInPicture
            onContextMenu={(e) => e.preventDefault()}
          
            />
         </Paper>
        </Grid>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2, height: '100%', position: 'relative', overflow: 'hidden' }}>
              <Box sx={{
                height: 280,
                backgroundColor: 'grey.200',
                backgroundImage: 'url(/foot.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                borderRadius: 1
              }} />
              <Paper sx={{ p: 2, mt: -6, position: 'relative', bgcolor: 'rgba(255,255,255,0.9)' }}>
                <Typography variant="h6" sx={{ mb: 1 }}>{t.footHeader}</Typography>
                <ul style={{ margin: 0, paddingInlineStart: 18 }}>
                  <li><Typography variant="body2">{t.bullet1}</Typography></li>
                  <li><Typography variant="body2">{t.bullet2}</Typography></li>
                  <li><Typography variant="body2">{t.bullet3}</Typography></li>
                </ul>
              </Paper>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2, height: '100%', position: 'relative', overflow: 'hidden' }}>
              <Box sx={{
                height: 280,
                backgroundColor: 'grey.200',
                backgroundImage: 'url(/table.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                borderRadius: 1
              }} />
              <Paper sx={{ p: 2, mt: -6, position: 'relative', bgcolor: 'rgba(255,255,255,0.9)' }}>
                <Typography variant="h6" sx={{ mb: 1 }}>{t.bodyHeader}</Typography>
                <ul style={{ margin: 0, paddingInlineStart: 18 }}>
                  <li><Typography variant="body2">{t.bullet4}</Typography></li>
                  <li><Typography variant="body2">{t.bullet5}</Typography></li>
                  <li><Typography variant="body2">{t.bullet6}</Typography></li>
                </ul>
              </Paper>
            </Paper>
          </Grid>
        </Grid>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>{t.paragraphheader}</Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          {t.paragraph}
        </Typography>

        {/* Form */}
        <Box ref={formRef}>
          <Typography ref={formHeaderRef} variant="h5" sx={{ fontWeight: 600, mb: 2 }}>{t.formHeader}</Typography>

          {submitted ? (
            <Alert severity="success">{t.thankYou}</Alert>
          ) : (
            <Paper component="form" onSubmit={handleSubmit} sx={{ p: 3 }}>
              {submitError && (
                <Alert severity="error" sx={{ mb: 2 }}>{submitError}</Alert>
              )}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={t.firstName}
                    fullWidth
                    name="firstName"
                    required
                    value={form.firstName}
                    onChange={(e) => setForm({ ...form, firstName: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={t.lastName}
                    fullWidth
                    required
                    value={form.lastName}
                    onChange={(e) => setForm({ ...form, lastName: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={t.email}
                    fullWidth
                    required
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    error={!!errors.email}
                    helperText={errors.email?t.emailError:false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={t.phone}
                    key="p"
                    fullWidth
                    required
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                    error={!!errors.phone}
                    helperText={errors.phone?t.phoneError:false}
                  />
                </Grid>
                <Grid item xs={12}>
                  { days[language] && days[language].map((day, index) => (
                    <Grid container spacing={2} key={index}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body1" color="text.primary" sx={{ mb: 1, fontWeight: 600, marginBottom: '1px' }}>{day}</Typography>
                        <FormControlLabel
                            sx={{ marginRight: '5px' }}
                            key={index+'m'}
                            control={<Checkbox style={{ marginRight: '-5px' }}
                                checked={availability[index] && availability[index]['morning']}
                                onChange={() => updateAvailablityGrid(index, 'morning', availability)}
                            />}
                            label={t.morning}
                            />  
                        <FormControlLabel
                        
                            sx={{ marginRight: '5px' }}
                            key={index+'a'}
                            control={<Checkbox style={{ marginRight: '-5px' }}
                                checked={availability[index] && availability[index]['afternoon']}
                                onChange={() => updateAvailablityGrid(index, 'afternoon', availability)}
                            />}
                            label={t.afternoon}
                            />  
                        <FormControlLabel
                        
                            sx={{ marginRight: '5px' }}
                            key={index+'e'}
                            control={<Checkbox style={{ marginRight: '-5px' }}
                                checked={availability[index] && availability[index]['evening']}
                                onChange={() => updateAvailablityGrid(index, 'evening', availability)}
                            />}
                            label={t.evening}
                            /> 
                    </Grid>
                    </Grid>
                  ))}
                  {errors.availability && ( 
                    <Typography variant="body2" color="error" sx={{ mb: 1, fontWeight: 600, marginBottom: '1px' }}>{t.availabilityError}</Typography>
                  )}
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label={t.practitionerPreference}
                    value={form.practitionerPreference}
                    onChange={(e) => setForm({ ...form, practitionerPreference: e.target.value })}
                  >
                    <MenuItem value={t.noPreference}>{t.noPreference}</MenuItem>
                    {practitioners.map((practitioner) => (
                      <MenuItem key={practitioner} value={practitioner}>{practitioner}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={t.comments}
                    fullWidth
                    multiline
                    minRows={3}
                    value={form.comments}
                    onChange={(e) => setForm({ ...form, comments: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox
                            checked={form.privacyPolicy}
                            onChange={(e) => setForm({ ...form, privacyPolicy: e.target.checked })}
                        />}
                        label={t.privacyPolicy}
                    />
                    {errors.privacyPolicy && (
                        <Typography variant="body2" color="error">{t.privacyPolicyError}</Typography>
                    )}
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                  <Button type="submit" variant="contained" disabled={submitting}>
                    {submitting ? '...' : t.submit}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          )}
        </Box>
      </Container>

      {/* Sticky CTA */}
      <Slide direction="up" in={showStickyCTA && !submitted} mountOnEnter unmountOnExit>
        <Box sx={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(255, 255, 255, 0)',
          py: 1,
          zIndex: (t) => t.zIndex.appBar,
        }}>
          <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" size="large" onClick={scrollToForm}>
              {t.cta}
            </Button>
          </Container>
        </Box>
      </Slide>

      <Footer hideBranding />
    </Box>
  );
};

export default Promotions;